export default __webpack_public_path__ + "static/media/bg_component_3.78899868.jpg";